import React from "react";
import Container from "@mui/material/Container";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Icon from "@mui/material/Icon";
import { LITIGATION_RECS_TITLE, LITIGATION_RECS_DESCRIPTION } from "dail/constants/textVariables";

const SuggestionsCard = () => (
  <Container sx={{ mt: 4, maxWidth: 600 }}>
    <MKBox
      sx={{
        p: 3,
        pt: 0,
        borderRadius: 2,
        textAlign: "left",
        maxWidth: 600,
      }}
    >
      <MKTypography variant="h4" fontWeight="bold" mb={0.5}>
        {LITIGATION_RECS_TITLE}
      </MKTypography>
      <MKTypography variant="body1" color="text">
        {LITIGATION_RECS_DESCRIPTION}
      </MKTypography>
      <MKTypography
        pt={2}
        component="a"
        href="https://blogs.gwu.edu/law-eti/suggestions-for-the-ai-litigation-database/"
        target="_blank"
        rel="noreferrer"
        variant="body2"
        color="#003c5a"
        fontWeight="bold"
        sx={{
          display: "flex",
          alignItems: "center",
          "& .material-icons-round": {
            fontSize: "1.125rem",
            transform: `translateX(3px)`,
            transition: "transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)",
          },
          "&:hover .material-icons-round, &:focus .material-icons-round": {
            transform: `translateX(6px)`,
          },
        }}
      >
        Contact Form <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
      </MKTypography>
    </MKBox>
  </Container>
);

export default SuggestionsCard;